import React from "react";

export const CloseQuoteIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="58" height="204" viewBox="0 0 58 204">
      <text id="_" data-name="”" transform="translate(0 153)" fill="#ed0000" font-size="170" font-family="BebasNeue-Regular, Bebas Neue"><tspan x="0" y="0">”</tspan></text>
    </svg>
  );
};


export const OpenQuoteIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="58" height="204" viewBox="0 0 58 204">
      <text id="_" data-name="“" transform="translate(0 153)" fill="#ed0000" font-size="170" font-family="BebasNeue-Regular, Bebas Neue"><tspan x="0" y="0">“</tspan></text>
    </svg>
  );
};